var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"auth-brand-footer",class:{ 'auth-brand-footer--fixed': _vm.fixed }},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"auth-brand-footer__text"},[_c('strong',[_vm._v("رو ب رو")]),_c('span',{staticClass:"auth-brand-footer__sep"},[_vm._v("|")]),_vm._v(" پلتفرم تخصصی مشاوره آنلاین روانشناسی ")])
}]

export { render, staticRenderFns }